// Team Live mock data (approved HTML:
// 11-Team-Live-Consistency-Review-v4.html).
//
// Doug's world: Jamie Dorsey is the signed-in rep elsewhere; here he
// shows in the team roster because this is the Manager rail. All other
// names are placeholder sales reps for the 100X Equine Dallas team.
// Metrics intentionally use round illustrative amounts. No real revenue.
//
// TODO(runtime): swap mock -> real services:
//   - services/manager-presence (teamPresence, repId, status, focus)
//   - services/sales-queue-pressure (priorityQueues)
//   - services/manager-exceptions (attribution/coverage conflicts)
//   - services/source-health (feed freshness, routing status)

export type RepStatus = 'available' | 'engaged' | 'break';

export interface TeamLiveRep {
  id: string;
  name: string;
  status: RepStatus;
  statusLabel: string;
  focus: string;
  creditedToday: string;
  openWork: number;
}

export interface QueueRow {
  workType: string;
  waiting: number;
  oldest: string;
  handling: string;
  tone?: 'green' | 'amber' | 'red' | 'default';
}

export interface ExceptionRow {
  id: string;
  kind: 'attribution' | 'coverage';
  title: string;
  body: string;
  cta: string;
}

export interface TeamLiveMetricsSnapshot {
  snapshotDate: string;
  snapshotTime: string;
  creditedSalesToday: string;
  creditedCaption: string;
  availableReps: string;
  availableCaption: string;
  openWork: string;
  openWorkCaption: string;
  exceptions: string;
  exceptionsCaption: string;
}

export const TEAM_LIVE_METRICS: TeamLiveMetricsSnapshot = {
  snapshotDate: 'September 30, 2026',
  snapshotTime: '1:00 PM',
  creditedSalesToday: '$7,810',
  creditedCaption: 'Confirmed credited sales · Example',
  availableReps: '3 of 6',
  availableCaption: '2 engaged · 1 on break',
  openWork: '18',
  openWorkCaption: 'System-ranked customer actions',
  exceptions: '2',
  exceptionsCaption: 'Items needing manager attention',
};

export const TEAM_LIVE_REPS: TeamLiveRep[] = [
  {
    id: 'rep_jamie_dorsey',
    name: 'Jamie Dorsey',
    status: 'engaged',
    statusLabel: 'engaged',
    focus: 'Sarah Mitchell · Text',
    creditedToday: '$1,680',
    openWork: 3,
  },
  {
    id: 'rep_carter_pope',
    name: 'Carter Pope',
    status: 'available',
    statusLabel: 'available',
    focus: 'Ready for next customer',
    creditedToday: '$1,440',
    openWork: 4,
  },
  {
    id: 'rep_mia_ramirez',
    name: 'Mia Ramirez',
    status: 'engaged',
    statusLabel: 'engaged',
    focus: 'Michael Thompson · Call',
    creditedToday: '$1,260',
    openWork: 3,
  },
  {
    id: 'rep_sean_oconnor',
    name: 'Sean O’Connor',
    status: 'available',
    statusLabel: 'available',
    focus: 'Ready for next customer',
    creditedToday: '$980',
    openWork: 2,
  },
  {
    id: 'rep_bailey_fitz',
    name: 'Bailey Fitzpatrick',
    status: 'break',
    statusLabel: 'break',
    focus: 'Break until 1:15 PM',
    creditedToday: '$1,350',
    openWork: 3,
  },
  {
    id: 'rep_jade_navarro',
    name: 'Jade Navarro',
    status: 'available',
    statusLabel: 'available',
    focus: 'Ready for next customer',
    creditedToday: '$1,100',
    openWork: 3,
  },
];

export const QUEUE_PRIORITIES: QueueRow[] = [
  { workType: 'Customer replies', waiting: 7, oldest: '12 min', handling: 'Routing active', tone: 'green' },
  { workType: 'Requested callbacks', waiting: 3, oldest: 'Next due 1:15 PM', handling: 'Scheduled' },
  { workType: 'Product follow-ups', waiting: 5, oldest: 'Today', handling: 'Ranked by system' },
  { workType: 'Retention follow-ups', waiting: 3, oldest: 'Today', handling: 'Eligibility checked' },
];

export const EXCEPTIONS: ExceptionRow[] = [
  {
    id: 'exc_attribution_sample',
    kind: 'attribution',
    title: 'Attribution evidence conflict',
    body: 'One order has conflicting source events. No commission assigned while unresolved.',
    cta: 'View evidence →',
  },
  {
    id: 'exc_coverage_sample',
    kind: 'coverage',
    title: 'Coverage gap',
    body: 'A scheduled callback needs an available qualified rep.',
    cta: 'Review coverage →',
  },
];

export const SYSTEM_HEALTH = {
  routing: 'Routing available',
  delayed: '1 delayed feed',
  description:
    'Subscription events are delayed in this sample. Show source freshness before promising dates.',
};
